module.exports = __webpack_public_path__ + "static/media/water-fire-theft-icon@2x.18c05215.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/water-fire-theft-icon@2x.png
// module id = 1274
// module chunks = 0